/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

/**
 * Code used to identify the ACH authorization method.
 */
export const SECCode = {
  Web: "WEB",
  Ppd: "PPD",
  Ccd: "CCD",
  Tel: "TEL",
} as const;
/**
 * Code used to identify the ACH authorization method.
 */
export type SECCode = ClosedEnum<typeof SECCode>;

/** @internal */
export const SECCode$inboundSchema: z.ZodNativeEnum<typeof SECCode> = z
  .nativeEnum(SECCode);
/** @internal */
export const SECCode$outboundSchema: z.ZodNativeEnum<typeof SECCode> =
  SECCode$inboundSchema;
